import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { BrManageContentButton, BrManageMenuButton } from '@bloomreach/react-sdk';
import { NewsletterBanner } from '@grandvisionhq/content';
import { Footer, FooterLinks } from '@grandvisionhq/layout';
import { useBrPageContext, useBrComponentContext } from '../../context/context.js';
import '../../context/configuration.js';
import { useMeta } from '../../context/MetaContext.js';
import '@grandvisionhq/state';
import '@bloomreach/spa-sdk';
import '@grandvisionhq/search';
import 'jsonpointer';
import '@grandvisionhq/utils';
import '@grandvisionhq/common';
import '../../utils/http-client.js';
import '@grandvisionhq/lib-utils-html';
import { useBloomreachNewsletterData } from '../../hooks/use-bloomreach-newsletter-data.js';
import { useBloomreachNewsletterV2Data } from '../../hooks/use-bloomreach-newsletter-v2-data.js';
import { useBloomreachSiteLogos } from '../../hooks/use-bloomreach-site-logos.js';
import '../../hooks/use-breakpoint-visibility.js';
import '@grandvisionhq/graphql';
import '../../operations/mutations/signup-promotion.js';
import '../../operations/mutations/subscribe-newsletter.js';
import '../../operations/mutations/subscribe-newsletter-opt-in.js';
import '@grandvisionhq/svc-tealium/events';
import { getMenuItems } from '../../utils/get-menu-items.js';

const CmsFooter = ({ useAlternativeLogoInFooter =true  })=>{
    var ref;
    const { site  } = useMeta();
    const siteLogos = useBloomreachSiteLogos();
    const page = useBrPageContext();
    const component = useBrComponentContext();
    const newsletterData = useBloomreachNewsletterData();
    const newsletterDataV2 = useBloomreachNewsletterV2Data();
    const preview = page === null || page === void 0 ? void 0 : page.isPreview();
    var ref1;
    const siteName = (ref1 = site === null || site === void 0 ? void 0 : site.name) !== null && ref1 !== void 0 ? ref1 : 'Unknown';
    const fallbackLogo = useAlternativeLogoInFooter ? siteLogos.alternative : siteLogos.main;
    const logoUrl = siteLogos.logoFooter || fallbackLogo;
    const logo = logoUrl ? {
        url: logoUrl,
        altText: siteName
    } : undefined;
    if (!page || !component) {
        return null;
    }
    /* Footer content */ const { document: documentRef  } = component.getModels();
    const document = page.getContent(documentRef);
    const content = document === null || document === void 0 ? void 0 : document.getData();
    /* Footer bottom menu */ const { menuItems , menu  } = getMenuItems('menu', component, page);
    const newsletterProps = swcHelpers.objectSpread({}, newsletterData, {
        modalButtonTitle: content === null || content === void 0 ? void 0 : (ref = content.newsletterModal) === null || ref === void 0 ? void 0 : ref.modalButtonTitle
    });
    return /*#__PURE__*/ React.createElement(React.Fragment, null, preview && document && /*#__PURE__*/ React.createElement("div", {
        style: {
            position: 'relative'
        }
    }, /*#__PURE__*/ React.createElement(BrManageContentButton, {
        content: document
    })), content && /*#__PURE__*/ React.createElement(React.Fragment, null, newsletterDataV2 ? /*#__PURE__*/ React.createElement(NewsletterBanner, swcHelpers.extends({}, newsletterDataV2)) : null, /*#__PURE__*/ React.createElement(Footer, swcHelpers.extends({}, content, {
        logo: logo,
        newsletterProps: newsletterProps,
        hasNewsletterV2: !!newsletterDataV2,
        siteName: siteName
    }), (menuItems === null || menuItems === void 0 ? void 0 : menuItems.length) > 0 && /*#__PURE__*/ React.createElement(React.Fragment, null, preview && menu && /*#__PURE__*/ React.createElement("div", {
        style: {
            position: 'relative'
        }
    }, /*#__PURE__*/ React.createElement(BrManageMenuButton, {
        menu: menu
    })), /*#__PURE__*/ React.createElement(FooterLinks, {
        items: menuItems
    })))));
};

export { CmsFooter, CmsFooter as default };
//# sourceMappingURL=Footer.js.map
